export default {
  base_url: 'https://api.pandits.id/',
  // base_url: 'https://pandora-api.komunestudio.com/',
  booking_website_url : 'https://play.pandoraexperience.com/bookings?tab=upcoming',
  pandits_url : 'https://pandits.id/',
  // booking_website_url : 'https://play-pandora.komunestudio.com/bookings?tab=upcoming',
};
